import React from 'react';
import './styles.scss';
export interface Props {
  name: string;
  puckCount: number;
  slotAvailable: number;
  onDewarCardClickHandler: () => void;
}

const Dewar = (props: Props) => {
  const { name, puckCount, slotAvailable, onDewarCardClickHandler } = props;

  return (
    <div
      id="cardtemplates-dewar-wrapper"
      className={
        slotAvailable
          ? 'puck-dewar-card-available-style'
          : 'puck-dewar-card-disabled-style'
      }
      onClick={slotAvailable ? onDewarCardClickHandler : null}
    >
      <div
        id="cardtemplates-dewar-name"
        className="w-full text-[#474747] text-base font-normal"
      >
        {name}
      </div>
      <div id="cardtemplates-dewar-details" className="flex flex-row w-full">
        <div
          id="cardtemplates-dewar-puck-count"
          className="w-1/3 text-[#313131] text-base font-semibold"
        >{`Puck Count: ${puckCount}`}</div>
        <div
          id="cardtemplates-dewar-slot-available"
          className="w-1/3 text-[#313131] text-base font-semibold"
        >{`Slot Available: ${slotAvailable}`}</div>
      </div>
    </div>
  );
};

export default Dewar;
